import React from "react";
import type {VoidFunctionComponent} from "react";

export interface ICourseOverviewListItemProps {
  content: string;
}

export const CourseOverviewListItem: VoidFunctionComponent<ICourseOverviewListItemProps> = ({content}) => {
  return <li>{content}</li>;
}

